import React from "react";

import { createColumnHelper } from "@tanstack/react-table";
import CrudActions from "components/crud/CrudActions";


const columnHelper = createColumnHelper();


const getStatusClass = (status) => {

    switch (status) {

        case "active":
            return "bg-green-100 text-green-700";

        case "inactive":
            return "bg-red-100 text-red-700";

        default:
            return "bg-gray-100 text-gray-700";

    }
};


export const bookColumns = ({
    onEdit,
    onDelete,
} = {}) => {

    return [

        // =====================================================
        // BOOK CODE
        // =====================================================

        columnHelper.accessor(
            "bookCode",
            {
                id: "bookCode",

                header: "Book Code",

                cell: (info) => (
                    <span className="font-medium">
                        {info.getValue() || "-"}
                    </span>
                ),
            }
        ),


        // =====================================================
        // TITLE
        // =====================================================

        columnHelper.accessor(
            "title",
            {
                id: "title",

                header: "Title",

                cell: (info) => (
                    <div className="max-w-xs">
                        <div className="font-semibold text-white-700">
                            {info.getValue() || "-"}
                        </div>
                    </div>
                ),
            }
        ),


        // =====================================================
        // ISBN
        // =====================================================

        columnHelper.accessor(
            "isbn",
            {
                id: "isbn",

                header: "ISBN",

                cell: (info) => (
                    <span className="text-sm">
                        {info.getValue() || "-"}
                    </span>
                ),
            }
        ),


        // =====================================================
        // PUBLISHER
        // =====================================================

        columnHelper.accessor(
            "publisher",
            {
                id: "publisher",

                header: "Publisher",

                cell: (info) => (
                    <span>
                        {info.getValue() || "-"}
                    </span>
                ),
            }
        ),


        // =====================================================
        // CLASS
        // =====================================================

        columnHelper.accessor(
            "className",
            {
                id: "className",

                header: "Class",

                cell: (info) => (
                    <span>
                        {info.getValue() || "-"}
                    </span>
                ),
            }
        ),


        // =====================================================
        // SUBJECT
        // =====================================================

        columnHelper.accessor(
            "subject",
            {
                id: "subject",

                header: "Subject",

                cell: (info) => (
                    <span>
                        {info.getValue() || "-"}
                    </span>
                ),
            }
        ),


        // =====================================================
        // LANGUAGE
        // =====================================================

        columnHelper.accessor(
            "language",
            {
                id: "language",

                header: "Language",

                cell: (info) => (
                    <span>
                        {info.getValue() || "-"}
                    </span>
                ),
            }
        ),


        // =====================================================
        // STATUS
        // =====================================================

        columnHelper.accessor(
            "status",
            {
                id: "status",

                header: "Status",

                cell: (info) => {

                    const value =
                        info.getValue();

                    return (
                        <span
                            className={`
                                inline-flex
                                rounded-full
                                px-3
                                py-1
                                text-xs
                                font-semibold
                                capitalize
                                ${getStatusClass(value)}
                            `}
                        >
                            {value || "-"}
                        </span>
                    );
                },
            }
        ),


        // =====================================================
        // ACTIONS
        // =====================================================

        columnHelper.display(
        
        {
            id: "actions",
            header: "Actions",

            cell: ({ row }) => {

                const item = row.original;

                return (
                    <CrudActions
                        onEdit={() =>
                            onEdit(item)
                        }

                        onDelete={() =>
                            onDelete(item)
                        }

                        editTitle="Edit Book"
                        deleteTitle="Delete Book"
                    />
                );
            },
        },
    ),

    ];
};